import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ModuleFE_PermissionAccessLevel, ModuleFE_PermissionAPI, ModuleFE_PermissionDomain } from '../../../_entity.js';
import { Component_BasePermissionItemEditor } from '../editor-base.js';
import { sortArray } from '@nu-art/ts-common';
import { TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { MultiSelect } from '../../ui-props.js';
import { TS_Icons } from '@nu-art/ts-styles';
import { Page_ItemsEditor } from '@nu-art/thunderstorm-frontend/components/Page_ItemsEditor/index';
import './permission-api-editor.scss';
import { TS_EditableItemControllerProto } from '@nu-art/thunderstorm-frontend/editable-item';
class Component_APIEditor extends Component_BasePermissionItemEditor {
    static defaultProps = {
        module: ModuleFE_PermissionAPI,
        displayResolver: (item) => item.path
    };
    editorContent = () => {
        const api = this.state.editable;
        if (!api)
            return;
        return _jsxs(_Fragment, { children: [_jsx(TS_PropRenderer.Vertical, { label: 'Path', children: _jsx("div", { children: api.item.path }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Access Levels', children: _jsx(MultiSelect.AccessLevel, { editable: api, prop: 'accessLevelIds', className: 'domain-level-list', itemRenderer: (levelId, onDelete) => {
                            const level = ModuleFE_PermissionAccessLevel.cache.unique(levelId);
                            const domain = ModuleFE_PermissionDomain.cache.unique(level.domainId);
                            return _jsxs("div", { className: 'domain-level-list__item', children: [_jsx(TS_Icons.x.component, { onClick: onDelete }), `${domain.namespace}: ${level.name} (${level.value})`] }, levelId);
                        } }) })] });
    };
}
class Controller_ApiEditor extends TS_EditableItemControllerProto {
    static defaultProps = {
        module: ModuleFE_PermissionAPI,
        editor: Component_APIEditor,
        keys: ['selected'],
        createInitialInstance: () => ({}),
        autoSave: true
    };
}
export class PermissionAPIEditor extends Page_ItemsEditor {
    //######################### Static #########################
    static Route = {
        key: 'api-permission-editor',
        path: 'api-permission-editor',
        Component: this,
    };
    static defaultProps = {
        keys: ['selected'],
        module: ModuleFE_PermissionAPI,
        mapper: api => [api.path],
        sort: (items) => sortArray(items, 'path'),
        id: 'api-permission-editor',
        itemRenderer: api => _jsx(_Fragment, { children: api.path }),
        EditorRenderer: (props) => _jsx(Controller_ApiEditor, { ...props }),
        hideAddItem: true,
        route: this.Route,
    };
    //######################### Lifecycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.filter = item => item.projectId === nextProps.projectId;
        return state;
    }
    renderHeader() {
        return _jsx(_Fragment, { children: "Permission APIs" });
    }
}
//# sourceMappingURL=permission-api-editor.js.map